import React, { forwardRef, useImperativeHandle, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Box, Button, Paper } from "@mui/material"; // Import the Button component
import { useThemes } from "../../components/Theme/theme";
import dayjs from "dayjs";

/**
 * @deprecated ❌ ~~CustomDate~~ is deprecated. 
 * Please use `DateRangeRsuite` instead.
 */
const CustomDate = forwardRef(({ onChange, value, sx }, ref) => {
  console.warn("⚠️ CustomDate is deprecated. Use DateRangeRsuite instead.");
  const [open, setOpen] = useState(false);
  const { theme } = useThemes();

  const theme1 = createTheme({
    palette: {
      mode: theme.palette.mode,
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: "10px", // Set the font size for input text
            "&::placeholder": {
              fontSize: "10px", // Set the font size for placeholder text
            },
            maxWidth: "180px",
            padding: "5px !important",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            minWidth: "100px !important", // Set the minimum width for TextField
            maxWidth: "180px", // Additionally, you can enforce a maximum width
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            border: "none", // Set border to none
          },
        },
      },
    },
  });
  useImperativeHandle(ref, () => ({
    openDatePicker: () => setOpen(true),
    closeDatePicker: () => setOpen(false),
  }));

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ThemeProvider theme={theme1}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["SingleInputDateRangeField"]}>
          {/* Apply zero padding to the parent div using the Box component */}
          <Box sx={{ p: 0 }}>
            <DateRangePicker
              format="DD/MM/YYYY"
              placeholder="DD/MM/yyy"
              open={open}
              onClose={handleClose}
              className="test"
              sx={{ width: "180px", "& > div": { padding: 0 }, ...sx }}
              slots={{ field: SingleInputDateRangeField }}
              name="allowedRange"
              value={value}
              onOpen={handleOpen} // Ensures that the calendar opens when interacting with the input
              onChange={(newValue) => {
                const newFrom = newValue[0] ? newValue[0]?.unix() : null;
                const newTo = newValue[1]
                  ? dayjs(newValue[1]).endOf("day").unix()
                  : null;
                onChange({ from: newFrom, to: newTo });
              }}
            />
          </Box>
        </DemoContainer>
      </LocalizationProvider>
    </ThemeProvider>
  );
});

export default CustomDate;
